import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth-guard';
import { guestGuard } from './core/auth/guest-guard';
import { defaultLandingRedirect } from './core/auth/default-landing-redirect';
import { formatPageTitle } from './core/utils/page-title';

export const appRoutes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: '',
    loadComponent: () => import('./layout/main-layout/main-layout').then((m) => m.MainLayout),
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: defaultLandingRedirect },
      {
        path: 'access-denied',
        title: formatPageTitle('Access Denied'),
        loadComponent: () =>
          import('./core/pages/access-denied/access-denied').then((m) => m.AccessDenied),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
      },
      {
        path: 'intake',
        loadChildren: () => import('./features/intake/intake.routes').then((m) => m.INTAKE_ROUTES),
      },
      {
        path: 'contracts',
        loadChildren: () =>
          import('./features/contracts/contracts.routes').then((m) => m.CONTRACTS_ROUTES),
      },
      {
        path: 'reminders',
        loadChildren: () =>
          import('./features/reminders/reminders.routes').then((m) => m.REMINDERS_ROUTES),
      },
      {
        path: 'search',
        loadChildren: () => import('./features/search/search.routes').then((m) => m.SEARCH_ROUTES),
      },
      {
        path: 'access-control',
        loadChildren: () =>
          import('./features/access-control/access-control.routes').then(
            (m) => m.ACCESS_CONTROL_ROUTES
          ),
      },
    ],
  },
  { path: '**', redirectTo: defaultLandingRedirect },
];
